/**
 * Auth Store (Zustand)
 * Manages authentication tokens and user session
 */

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import type { User } from '../types/auth.types';

// Test credentials for demo login
export const TEST_CREDENTIALS = {
  email: 'admin@falconai.app',
  password: 'Admin@2026',
} as const;

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
}

interface AuthActions {
  setAuth: (user: User, token: string) => void;
  logout: () => void;
}

type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      setAuth: (user, token) => {
        set({ user, token, isAuthenticated: true });
      },

      logout: () => {
        set({ user: null, token: null, isAuthenticated: false });
      },
    }),
    {
      name: 'falcon-terminal-auth',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
